import { createContext } from "react";
const ReligionContext = createContext({});

export default ReligionContext;
